<template>
  <div class="container-fluid">
    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">{{ module }}</h4>

          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item">
                <router-link :to="{name:'dashboards'}">Dashboards</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link :to="{name:table_module}">{{ module }}</router-link>
              </li>
              <li class="breadcrumb-item active">Import</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <!-- end page title -->
    <keep-alive>
      <upload_import :module="module" :table_module="table_module" :alias_table="alias_table"></upload_import>
    </keep-alive>
  </div>
</template>

<script>
import upload_import from "@/components/import";

export default {
  data() {
    return {
      module: "Toko",
      table_module: "store",
      alias_table: "str",
    };
  },
  components: {
    upload_import,
  },
};
</script>